export default __webpack_public_path__ + "static/media/fflogo.6c0940b9.svg";